import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { NavLink } from 'react-router-dom';
import routes from '../../helpers/ApplicationRoutes';

import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';

const ApplicationChips = props => {
    const { bucket, classes } = props;
    const { id: bucketId, organizationId, visibleInApplications } = bucket;

    const chips = visibleInApplications
        .filter(app => !app.hide)
        .sort((a, b) => a.name.toString().localeCompare(b.name.toString()))
        .map(application => {
            const route = routes.bucketAssets.getPath({
                bucketId,
                organizationId,
                application: application.id,
            });

            let applicationChip;
            if (application.icons) {
                applicationChip = (
                    <Chip
                        className={classes.app}
                        label={application.name}
                        avatar={
                            <Avatar
                                alt={application.name}
                                className={classes.avatar}
                                src={application.icons.tab}
                            />
                        }
                        variant="outlined"
                    />
                );
            } else {
                applicationChip = (
                    <Chip
                        className={classes.app}
                        label={application.name}
                        variant="outlined"
                    />
                );
            }

            return (
                <NavLink
                    to={route}
                    key={application.id}
                    activeClassName={classes.active}
                >
                    {applicationChip}
                </NavLink>
            );
        });

    return <div className={classes.wrapper}>{chips}</div>;
};

ApplicationChips.propTypes = {
    bucket: PropTypes.object.isRequired,
    selectedApp: PropTypes.string,
};

const style = ({ spacing, palette }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        padding: [spacing.unit * 2, 0],
    },
    app: {
        cursor: 'pointer',
        marginRight: spacing.unit,
        backgroundColor: 'white',
        color: palette.text.gray2,
        fontWeight: '600',
        padding: 1,
        '&:hover': {
            border: `1px solid ${palette.border.main}`,
            padding: 0,
        },
    },
    active: {
        '& $app': {
            border: `1px solid ${palette.border.main}`,
            backgroundColor: palette.background.gray1Color,
            padding: 0,
        },
    },
    avatar: {
        width: '16px',
        height: '16px',
        borderRadius: 'unset',
        paddingLeft: '15px',
    },
});

export default injectSheet(style)(ApplicationChips);



// WEBPACK FOOTER //
// ./src/components/visibleInApplications/ApplicationChips.js